
import React, { FunctionComponent, useEffect, useState } from 'react';
import { BaseUploadCard, FileType, UploadStatus } from '@shopee/chatbot-ui/lib/components/BaseUpload';
import { FileUploadProps, showUploadErrorToast } from './FileUploadWrapper';
import { postImg } from '@/services/chat';
import reporter from '@/utils/report';

export const ImageUploadWrapper: FunctionComponent<FileUploadProps> = (props) => {
  const [status, setStatus] = useState(UploadStatus.Loading);
  const [, setUrl] = useState<string>();

  useEffect(() => {
    reporter.apiBatchReport({ type: 'count', value: { label: 'probing_form_upload_image_total' }});
    postImg(props.file)
      .catch((error) => {
        props.onRemove();
        showUploadErrorToast();

        reporter.apiLog(
          `【Probing Form Upload】image upload failed, errormsg:${JSON.stringify(error)}`,
          { level: 'error' },
        );
      })
      .then((res) => {
        if (res) {
          props.onSuccess(res.url);
          setUrl(res.url);
          setStatus(UploadStatus.Success);
          reporter.apiBatchReport({ type: 'count', value: { label: 'probing_form_upload_image_success' }});
        } else {
          props.onRemove();
          showUploadErrorToast();

          reporter.apiLog(
            `【Probing Form Upload】image upload failed, errormsg:${JSON.stringify(res)}`,
            { level: 'error' },
          );
        }
      });
  }, []);

  return (
    <BaseUploadCard
      file={{ type: FileType.Image, originFile: props.file, status, coverUrl: window.URL.createObjectURL(props.file) }}
      onRemove={props.onRemove}
      onPreview={props.onPreview}
      showRemoveIcon={props.showRemoveIcon}
    />
  );
};
